import {Fragment, memo, useRef} from 'react';

import CSS from './Switch.module.scss';
import Focus from './Focus';

export default memo(function Switch(props: {
  isOn: boolean;
  isDisabled?: boolean;
  callback: () => void;
  /** The delay between the clicks after the first click. */
  clickDelay?: number;
  className?: HTMLDivElement['className'];
}) {
  const lastClickTime = useRef(0);
  const Wrapper = props.isDisabled ? Fragment : Focus;

  /** Handles clicks on the element by ignoring repetitive clicks. */
  function clickHandler() {
    if (!props.isDisabled) {
      const currentTime = Date.now();
      if (currentTime - lastClickTime.current > (props.clickDelay || 0)) {
        lastClickTime.current = currentTime;
        props.callback();
      }
    }
  }

  return (
    <Wrapper {...(props.isDisabled ? {} : {hasAnimation: true})}>
      <div
        role="switch"
        aria-checked={props.isOn}
        className={[CSS.switch, props.className || ''].join(' ')}
        onClick={clickHandler}>
        <div className={[CSS.handle, props.isOn ? CSS.on : ''].join(' ')} />
      </div>
    </Wrapper>
  );
});
